import {useParams} from "react-router-dom"
import {Result} from "../../client/Result"
import {CrudForm} from "../common/CrudForm"
import {BuildingClient, Programme} from "../../client/BuildingClient"
import { useState} from "react"
import {SelectOption} from "../common/MuiSelect"
import {meteringOptionalRoute} from "../../Routes"
import {AsyncComponentP} from "../common/AsyncComponent";
import {formFields, optionalFields} from "./EditProgrammePage";

type InitialData = { allProgrammes: Programme[], buildingProgrammes: Programme[], selectableProgrammes: Programme[] };

interface AddProgrammePageProps {
    buildingClient: BuildingClient
    buildingId: number
    initialData: InitialData
}

interface ProgrammeFrom {
    programme: SelectOption
    minimumPriceInEurosPerMegawattHour: number
    participatesInCapacityBidding: boolean
}

interface AsyncAddProgrammePageProp{
    buildingClient: BuildingClient
}

export const AsyncAddProgrammePage= ({ buildingClient }: AsyncAddProgrammePageProp) =>{
    const { buildingId } = useParams()

    async function load() : Promise<Result<InitialData>> {
        const f = await buildingClient.retrieveAllProgrammes()
        const g = await buildingClient.retrieveBuildingProgrammes(Number(buildingId))

        return f.flatMap(all =>
            g.map(
                bp => ({allProgrammes: all, buildingProgrammes: bp, selectableProgrammes: all.filter(programme =>
                        !bp.some(buildingProg => buildingProg.name === programme.name)
                    )})
            )
        )
    }

    return <AsyncComponentP loaderFunction={load} dataPropName={'initialData'}>
        <AddProgrammePage buildingId={Number(buildingId)} buildingClient={buildingClient} initialData={{allProgrammes: [], buildingProgrammes:[], selectableProgrammes:[]}}/>
    </AsyncComponentP>
}

// Compute these during render - no need to store in state
const programmeOptions = (selectableProgrammes: Programme[]): SelectOption[] => selectableProgrammes?.map((programmes) => ({
    id: programmes.name,
    label: programmes.name
}))

const AddProgrammePage = ({buildingId, buildingClient, initialData}: AddProgrammePageProps) => {
    const [selectedProgramme, setSelectedProgramme] = useState<string | null>(null)

    const toSelectableOptions = programmeOptions(initialData.selectableProgrammes)

    function onChange(newState: Partial<ProgrammeFrom>): void {
        setSelectedProgramme(newState.programme?.label || null)
    }

    function handleSubmit(programmeForm: Partial<ProgrammeFrom>): Promise<Result<null>> {
        const {programme, minimumPriceInEurosPerMegawattHour, participatesInCapacityBidding} = programmeForm
        if (programme) {
            const price = minimumPriceInEurosPerMegawattHour ? parseInt(String(minimumPriceInEurosPerMegawattHour)) : undefined
            return buildingClient.addProgrammeToBuilding({name: programme.label, minimumPriceInEurosPerMegawattHour: price, participatesInCapacityBidding: participatesInCapacityBidding}, buildingId)
        } else {
            throw new Error('Submit must have a programme value')
        }
    }

    return initialData.allProgrammes.length > 0 && initialData.buildingProgrammes ?
        <CrudForm redirectPath={meteringOptionalRoute.withParams(buildingId)} fields={formFields(false, optionalFields(selectedProgramme),toSelectableOptions)} onSubmit={handleSubmit} onChange={onChange} /> : <></>
}